<template>
  <!-- 法务记录基础信息-组件 -->
  <el-descriptions title="法务记录基础信息" :column="4" class="descriptions-content">
    <el-descriptions-item label="原告">{{ data.plaintiff }}</el-descriptions-item>
    <el-descriptions-item label="被告">{{ data.defendant }}</el-descriptions-item>
    <el-descriptions-item label="被告代理人">{{ data.defendantAgent }}</el-descriptions-item>
    <el-descriptions-item label="诉讼标的额">{{ data.amountOfLitigation }}</el-descriptions-item>
    <el-descriptions-item label="案号">{{ data.caseNum }}</el-descriptions-item>
    <el-descriptions-item label="受理法院">{{ data.courtOfAppeal }}</el-descriptions-item>
    <el-descriptions-item label="主审法官姓名">{{ data.presidingJudgeName }}</el-descriptions-item>
    <!-- <el-descriptions-item label="主审法官联系电话">{{ data.presidingJudgePhone }}</el-descriptions-item> -->
    <el-descriptions-item label="诉讼阶段">{{ data.litigationStage }}</el-descriptions-item>
    <el-descriptions-item label="首次接收诉讼案件时间">{{ data.firstReceiveCase }}</el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: 'LegalDescriptions',
  props: {
    // 法务记录基础信息
    data: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>

